import React, { useEffect, useState } from 'react';
import ProductInvestmentDropdown from '../../shared/common-dropdown/ProductInvestmentDropdown';

function AddLead({ sendDataToParent, onLoad }) {
  const [getSelectedInvestment, setSelectedInvestment] = useState([]);
  const [getMobileNumber, setMobileNumber] = useState('');

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: value,
    }));

     if(name === "MobileNumber") {
      if (/^\d*$/.test(value)) {
        setMobileNumber(value);
      }else {
        return;
      }
    }

  }

 

  useEffect(() => {
    onLoad(undefined);
  }, []);

  

  // ✅ Capture multi-select dropdown changes
  function handleDropdownChange(selectedOptions) {
    setSelectedInvestment(selectedOptions || []);
    sendDataToParent((prevState) => ({
      ...prevState,
      ClientCompanyTypeIds: selectedOptions ? selectedOptions.map(opt => opt) : [],
    }));
  }

  return (
    <>
      <div className="row">
        {/* Customer Name */}
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">
              Client Name<span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="ClientName"
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Mobile Number */}
        <div className="col-lg-6 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">
              Mobile No<span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="MobileNumber"
              onChange={handleChange}
              maxLength="10"
              value={getMobileNumber}
            />
          </div>
        </div>

        {/* Email ID */}
        <div className="col-lg-6 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">
              Email ID<span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="EmailId"
              onChange={handleChange}
            />
          </div>
        </div>

        {/* ✅ Product Investment Multi-Select */}
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">
              Product Investment<span style={{ color: "red" }}>*</span>
            </label>
            <ProductInvestmentDropdown
              showTitle={false}
              selectedValue={getSelectedInvestment || []}
              onChangeDropdown={handleDropdownChange}
            />
          </div>
        </div>

        {/* Description */}
        <div className="col-lg-12">
          <div className="summer-description-box transfer mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control h-100"
              rows="3"
              name="Description"
              onChange={handleChange}
            />
            <p className="mt-1">Maximum 1000 Characters</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddLead;
